import { useEffect, useState } from "react";
import { API, api } from "@/lib/api";
import { SectionTitle } from "@/components/common";
import { Button } from "@/components/ui/button";
import { FileSpreadsheet, FileText } from "lucide-react";

export default function Reports() {
  const [reports, setReports] = useState([]);

  useEffect(() => {
    api.get("/reports/list").then((r) => setReports(r.data)).catch(() => {});
  }, []);

  const download = (key, format) => {
    window.open(`${API}/reports/${key}?format=${format}`, "_blank");
  };

  return (
    <div className="space-y-4" data-testid="reports-page">
      <SectionTitle>Reports — Excel & PDF</SectionTitle>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {reports.map((r) => (
          <div key={r.key} className="bg-card border border-border rounded-lg p-4 space-y-3 hover:bg-accent/30 transition-colors duration-200" data-testid={`report-card-${r.key}`}>
            <p className="font-heading font-semibold text-lg uppercase tracking-tight">{r.name}</p>
            <div className="flex gap-2">
              <Button size="sm" variant="outline" className="flex-1 border-signal-green/40 text-signal-green hover:bg-signal-green/10" onClick={() => download(r.key, "xlsx")} data-testid={`report-${r.key}-xlsx`}>
                <FileSpreadsheet className="w-4 h-4 mr-1" /> Excel
              </Button>
              <Button size="sm" variant="outline" className="flex-1 border-signal-red/40 text-signal-red hover:bg-signal-red/10" onClick={() => download(r.key, "pdf")} data-testid={`report-${r.key}-pdf`}>
                <FileText className="w-4 h-4 mr-1" /> PDF
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
